<template>
  <div>
    <el-row>
      <el-col>
        <rabbey-toolbox filterables @filter-search="handleSearch">
          <template>
            <div class="box mr-5">
              <EmployeeSelector
                :placeholder="'Creador Por'"
                :all="true"
                @selection-change="updateSelectedCreator"
              />
            </div>
            <div class="box mr-5">
              <EmployeeSelector
                :placeholder="'Responsable'"
                @selection-change="updateSelectedEmployee"
                @list-employee="employeList = $event"
                :DireccionParams="selectedDirection"
              />
            </div>

            <div class="box mr-5">
              <template
                v-if="
                  (currentUser.Roles.some((rol) => rol.Id == 13) &&
                    selectedDirection == 42) ||
                  (currentUser.Roles.some((rol) => rol.Id == 37) &&
                    selectedDirection == 42)
                "
              >
                <el-select
                  v-model="StatusSoftwareDeveloperSelected"
                  @change="getItems()"
                  :placeholder="'Progreso'"
                  size="mini"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, key) in StatusSoftwareDeveloperList"
                    :key="key"
                    :label="item.Label"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>

            <div class="box mr-5">
              <template
                v-if="
                  (currentUser.Roles.some((rol) => rol.Id == 13) &&
                    selectedDirection == 42) ||
                  (currentUser.Roles.some((rol) => rol.Id == 37) &&
                    selectedDirection == 42)
                "
              >
                <el-select
                  v-model="ChangesDirectionsIT"
                  @change="getItems()"
                  :placeholder="'Desarrollo'"
                  size="mini"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, key) in DirectionsITList"
                    :key="key"
                    :label="item.Label"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>

            <div class="box mr-5">
              <DirectionSelector
                @selection-change="updateSelectedDirection"
                @directionData="DirectionData"
              />
            </div>
          </template>
          <div class="box mr-20" v-if="!setAllMyRequests">
            <el-tooltip effect="dark">
              <div slot="content">
                Creadas por Mí: Todas las solicitudes que fueron creada por
                mi.<br />Asignadas a Mí: Todas las solicitudes asignadas a mi o
                que yo soy el supermisor del usuario asignado.
              </div>
              <el-switch
                v-model="switchCreateByMe"
                active-text="Creadas por Mí"
                inactive-text="Asignadas a Mí"
              >
              </el-switch>
            </el-tooltip>
          </div>

          <div class="box mr-20" v-if="currentUser.IsSupervisor">
            <el-tooltip effect="dark">
              <div slot="content">
                Ver todas las solicitudes, dependendiendo de mi rol esto
                muestra<br />
                todas las solicitudes que soy el supervisor o todas.
              </div>
              <el-switch
                v-model="setAllMyRequests"
                active-text="Todas las solicitudes"
              >
              </el-switch>
            </el-tooltip>
          </div>
          <div :offset="1" class="box mr-20" v-if="setAllMyRequests">
            <el-date-picker
              v-model="yearMonth"
              size="mini"
              type="month"
              placeholder="Selecciona el Mes y el Año"
            >
            </el-date-picker>
          </div>
        </rabbey-toolbox>
      </el-col>
    </el-row>

    <cardcountRequest
      :myRequestNewCount="cardValues.Nuevas"
      :myRequestInProgressCount="cardValues.EnProgreso"
      :myRequestInClosedCount="cardValues.PorValidar"
      :myRequestCancellCount="cardValues.Canceladas"
      :myRequestCompletedCount="cardValues.Completadas"
      :myRequestAllCount="cardValues.Todas"
    ></cardcountRequest>

    <el-dialog
      title="SUBIR EVIDENCIAS"
      :visible.sync="dialogVisible"
      width="30%"
      @close="onEvidenceClose"
    >
      <span>Subir Evidencias</span>

      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-change="handleChange"
        :on-remove="handleRemove"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos jpg/png con un tamaño menor de 26MG
        </div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" v-if="filesUpload > 0" @click="submitUpload"
          >Confirm</el-button
        >
      </span>
    </el-dialog>

    <el-row>
      <el-col>
        <el-card>
          <el-row>
            <el-col>
              <el-tabs
                v-model="activeTab"
                :before-leave="handleTabClick"
                @tab-click="OnTabClick"
              >
                <el-tab-pane label="Nuevas" name="new">
                  <rabbey-table3
                    border
                    ref="new"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="En Progreso" name="progress">
                  <rabbey-table3
                    border
                    ref="progress"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Por Calificar" name="closed">
                  <rabbey-table3
                    border
                    ref="closed"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Completadas" name="completed">
                  <rabbey-table3
                    border
                    ref="completed"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Todas" name="all">
                  <rabbey-table3
                    border
                    ref="all"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Canceladas" name="canceled">
                  <rabbey-table3
                    border
                    ref="canceled"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-button
        v-show="!loading"
        type="primary"
        icon="el-icon-download"
        @click="exportReport"
        >Exportar</el-button
      ><br
    /></el-row>
    <el-row>
      <el-card
        v-if="activeTab === 'progress'"
        class="flex-container"
        v-loading="loadingGraph"
        element-loading-text="Cargando Grafico"
      >
        <!--<h1>Helo Chart</h1>-->
        <!--<PolarAreaChart />-->
        <template>
          <el-card class="box-cardG">
            <h3 id="textG">Gráfico de solicitudes internas</h3>
            <div class="ChartSize">
              <pie-chart
                key="PieChartKey"
                ref="pieChart"
                :chartDataProp="chartData"
              ></pie-chart>
            </div>
          </el-card>
        </template>
      </el-card>
    </el-row>

    <InternalRequestDrawer
      :drawer.sync="showDetail"
      :data="detailData"
      @InternalRequestDrawerClose="closeInternalRequestDrawer"
    />

    <el-dialog
      width="30%"
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="handleCloseDialog"
    >
      <el-form ref="form" :model="dialog" :rules="rules[dialog.type]">
        <el-form-item v-if="dialog.type === 'set'" prop="responsableId">
          <el-select
            v-model="dialog.responsableId"
            placeholder="Seleccion personal a asignar"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="(resp, index) in filteredEmployeList"
              :key="index"
              :value="resp.value"
              :label="resp.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="dialog.type === 'setProgress'"
          prop="StatusSoftwareDeveloper"
        >
          <el-select
            v-model="dialog.StatusSoftwareDeveloper"
            placeholder="Selecciona el estado del progreso"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="(status, index) in StatusSoftwareDeveloperList"
              :key="index"
              :value="status.Id"
              :label="status.Label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="dialog.type === 'changesDirectionIT'"
          prop="ChangesDirectionsIT"
        >
          <el-select
            v-model="dialog.ChangesDirectionsIT"
            placeholder="Selecciona el estado del progreso"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="(status, index) in DirectionsITList"
              :key="index"
              :value="status.Id"
              :label="status.Label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="dialog.type === 'addComment'" prop="comment">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="Agrega tu comentario"
            v-model="dialog.comment"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          v-if="dialog.type === 'addcommentReasonToReopen'"
          prop="commentReasonToReopen"
          :rules="[
            {
              required: true,
              message:
                'Debes de agregar el comentario del porque se debe Reabrir la solicitud',
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="Agrega tu comentario del porque se debe 'Reabrir la solicitud'"
            v-model="dialog.commentReasonToReopen"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">Cancel</el-button>
        <el-button type="primary" @click="confirmDialog">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//import axios from "axios";
import { exportExcel } from "@/helpers/exportExcel";
import { getActions, COLUMNS } from "@/components/internal_requests/help_ir";
import InternalRequestDrawer from "@/components/internal_requests/InternalRequestDrawer.vue";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import cardcountRequest from "@/components/requests/internal/Cards.vue";
import PieChart from "@/components/Charts/PolarAreaChart.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorInternarRequest from "@/components/functionals/ColorInternarRequest";

export default {
  name: "InternalRequests",
  components: {
    EmployeeSelector,
    DirectionSelector,
    InternalRequestDrawer,
    cardcountRequest,
    PieChart
  },
  async mounted() {
    this.userDirection = this.currentUser.DireccionID;
    (this.selectedDirection =
      this.userDirection == 42 ? this.userDirection : this.selectedDirection),
      await this.getItems();
  },
  data() {
    let self = this;
    return {
      StatusSoftwareDeveloperSelected: null,
      StatusSoftwareDeveloperList: [
        { Id: 0, Label: "Sin empezar" },
        { Id: 1, Label: "Trabajando" },
        { Id: 2, Label: "En QA" }
      ],
      ChangesDirectionsIT: null,
      DirectionsITList: [
        { Id: 0, Label: "Nuevo Desarrollo" },
        { Id: 1, Label: "Solicitudes Internas" },
        { Id: 2, Label: "Solicitudes Externas" },
        { Id: 3, Label: "Infraestructura" },
        { Id: 4, Label: "Soporte Técnico" }
      ],
      userDirection: 0,
      disableCreatorSelector: false,
      disableEmployeeSelector: true,
      cardValues: {
        Nuevas: 0,
        EnProgreso: 0,
        PorValidar: 0,
        Todas: 0,
        Canceladas: 0
      },
      loading: false,
      showDetail: false,
      detailData: {
        requestsId: 0,
        comments: [],
        descripcionLaga: "",
        descripcionCorta: "",
        commentReasonToReopen: "",
        Reopen: ""
      },
      dialogVisible: false,
      fileList: [],
      filesUpload: 0,
      IDRequest: 0,
      activeTab: "new",
      selectedStatus: 0,
      setAllMyRequests: false,
      switchCreateByMe: false,
      switchIAmASupervisor: false,
      yearMonth: new Date(),
      search: "",
      selectedEmployee: 0,
      selectedDirection: 0,
      columns: COLUMNS,
      actions: self.getActions(self),
      items: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentPage2: 1,
      total2: 0,
      items2: [],
      requests: [],
      request: null,
      employeList: [],
      mapStatus: {
        new: 0,
        progress: 1,
        closed: 2,
        completed: 3,
        all: -1,
        canceled: 4
      },
      dialog: {
        StatusSoftwareDeveloper: 0,
        ChangesDirectionsIT: 0,
        type: "",
        title: "",
        visible: false,
        responsableId: null,
        comment: "",
        evidences: "",
        internalRequestId: 0,
        commentReasonToReopen: ""
      },
      rules: {
        set: {
          responsableId: [
            {
              required: true,
              message: "Debe indicar el responsable",
              trigger: "blur"
            }
          ]
        },
        addComment: {
          comment: [
            {
              required: true,
              message: "Debe introducir un comentario",
              trigger: "blur"
            },
            {
              min: 3,
              message: "Length should be 3",
              trigger: "blur"
            }
          ]
        }
      },
      Directions: [],
      PieChartKey: 0,
      loadingGraph: false,
      chartData: {
        labels: [],
        datasets: [
          {
            borderWidth: 1,

            borderColor: [],

            backgroundColor: [],

            data: []
          }
        ]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  computed: {
    updateInternalRequests() {
      return this.$store.state.updateInternalRequests;
    },
    filteredEmployeList() {
      const getEmployeeId = (employee) => Number(employee.EmployeeID);
      const sortByEmployeeIdAsc = (a, b) => getEmployeeId(a) - getEmployeeId(b);

      const isCeo = this.IsInRoles && this.IsInRoles([this.roles.CEO]);
      if (isCeo) {
        return this.employeList;
      }

      const currentEmployeeId = Number(
        this.currentUser && this.currentUser.EmployeeId
      );

      const allSubordinates = [];
      const visitedEmployeeIds = new Set();

      const collectSubordinates = (supervisorId) => {
        this.employeList
          .filter(
            (employee) =>
              Number(employee.SupervisorId || employee.SupervisorID) ===
              supervisorId
          )
          .forEach((employee) => {
            const employeeId = getEmployeeId(employee);
            if (
              !Number.isInteger(employeeId) ||
              visitedEmployeeIds.has(employeeId)
            ) {
              return;
            }

            visitedEmployeeIds.add(employeeId);
            allSubordinates.push(employee);
            collectSubordinates(employeeId);
          });
      };

      collectSubordinates(currentEmployeeId);

      return allSubordinates.sort(sortByEmployeeIdAsc);
    },
    progressColumns() {
      const columns = [];
      // if (

      //   (this.currentUser.Roles.some((rol) => rol.Id == 13) &&
      //     this.selectedDirection == 42) ||
      //   (this.currentUser.Roles.some((rol) => rol.Id == 37) &&
      //     this.selectedDirection == 42)
      // ) {
      columns.push(
        {
          prop: "Id",
          label: "No",
          minWidth: 80,
          fixed: true,
          sortable: true,
          formatter: ColorInternarRequest
        },
        {
          prop: "corta",
          label: "Descripcion",
          sortable: true,
          minWidth: 250
        },
        {
          prop: "Responsable",
          label: "Responsable",
          minWidth: 250,
          formatter: ImagePerson,
          sortable: true,
          attrs: {
            imgKey: "ResponsableImage"
          }
        },
        {
          prop: "CreateBy",
          label: "Creado Por",
          minWidth: 250,
          formatter: ImagePerson,
          sortable: true,
          attrs: {
            imgKey: "CreatorImage"
          }
        },
        {
          prop: "SlaDaysToResponse",
          label: "Sla (dias)",
          sortable: true,
          minWidth: 120
        },
        {
          prop: "DiasRetrasadosSla",
          label: "Atraso",
          sortable: true,
          minWidth: 120
        }
      );

      columns.push({
        prop: "DirectionsTI",
        label: "Dirección TI",
        minWidth: 190,
        //fixed: true,
        sortable: true,
        formatter: (row) => {
          return (
            this.DirectionsITList.find(
              (status) => status.Id == row.DirectionsTI
            ) || this.DirectionsITList.find((status) => status.Id == 0)
          ).Label;
        }
      });
      // }

      columns.push({
        prop: "StatusSoftwareDeveloper",
        label: "Estado",
        minWidth: 120,
        //fixed: true,
        sortable: true,
        formatter: (row) => {
          return (
            this.StatusSoftwareDeveloperList.find(
              (status) => status.Id == row.StatusSoftwareDeveloper
            ) ||
            this.StatusSoftwareDeveloperList.find((status) => status.Id == 0)
          ).Label;
        }
      });

      var columnsReturn = COLUMNS.filter(
        (item) =>
          !columns.some((itemB) => item.prop == itemB.prop) &&
          item.label != "No"
      );

      columns.push(...columnsReturn);

      return columns;
    }
  },
  methods: {
    async exportReport() {
      const columns = [];
      columns.push("No");
      if (
        this.currentUser.Roles.some((rol) => rol.Id == 13) &&
        this.currentUser.UserID !== 10 &&
        this.activeTab == "progress"
      ) {
        columns.push("Estado");
      }
      columns.push(
        "Fecha",
        "Tipo de Solicitud",
        "SLA",
        "Atraso",
        "Cumplimiento",
        "Descripcion",
        "Responsable",
        "Creado por",
        "Supervisor"
      );
      const items = this.items.map((item) => {
        const data = [item.Id];
        if (
          this.currentUser.Roles.some((rol) => rol.Id == 13) &&
          this.currentUser.UserID !== 10 &&
          this.activeTab == "progress"
        ) {
          data.push(
            (
              this.StatusSoftwareDeveloperList.find(
                (status) => status.Id == item.StatusSoftwareDeveloper
              ) ||
              this.StatusSoftwareDeveloperList.find((status) => status.Id == 0)
            ).Label
          );
        }
        data.push(
          item.CreatedAt,
          item.TipoSolicitud,
          item.SlaDaysToResponse,
          item.DiasRetrasadosSla,
          item.StatusSlaDescripcion,
          item.corta,
          item.Responsable,
          item.CreateBy,
          item.Supervisor
        );
        return data;
      });
      await exportExcel(columns, items, "Solicitudes");
    },
    getActions,
    OnTabClick() {
      //this.SetDataChart(this.items)
      if (this.activeTab === "progress") {
        //let self = this;
        this.currentPage = 1;
        this.selectedStatus = this.mapStatus[this.activeTab];
        this.getItemsForChart();
        //self.SetDataChart(self.items)
      }
    },
    handleTabClick(a) {
      let self = this;
      this.currentPage = 1;
      this.$nextTick(() => {
        self.selectedStatus = self.mapStatus[a];
        self.getItems();
        //self.SetDataChart(self.items)
      });
    },
    DirectionData(directions) {
      this.Directions = [
        directions[0],
        directions[2],
        directions[3],
        directions[5],
        directions[6],
        directions[7],
        directions[9]
      ];
      directions;
    },
    updateSelectedDirection(val) {
      this.selectedDirection = val;
      this.getItems();
    },
    updateSelectedCreator(val) {
      this.selectedCreator = val;
      this.getItems();
    },
    updateSelectedEmployee(val) {
      this.selectedEmployee = val;
      this.getItems();
    },

    tableRowClassName({ row: { CreatedAt, SlaDaysToResponse } }) {
      const now = this.$moment();
      var diference = now.diff(this.$moment(CreatedAt), "days");
      if (diference > SlaDaysToResponse) {
        return "warning-row";
      }
      return "";
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.getItems();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.getItems();
    },
    cancel() {
      this.request.cancel();
      this.clearOldRequest("Cancelled");
    },
    clearOldRequest(msg) {
      this.request.msg = msg;
      this.requests.push(this.request);
      this.request = null;
    },
    getItems() {
      /*
      if (this.request) this.cancel();

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      */
      const { /*EmployeeId,*/ CompanySelected, IsSupervisor } =
        this.currentUser;
      const person = this.selectedEmployee; //> 0 ? this.selectedEmployee : EmployeeId;

      const params = {
        PersonId: person,
        DirectionId: this.selectedDirection,
        Company: CompanySelected,
        Status: this.selectedStatus,
        CreateByMe: this.switchCreateByMe,
        IAmASupervisor: this.switchIAmASupervisor,
        All: this.setAllMyRequests,
        isSupervisor: IsSupervisor,
        page: this.currentPage,
        limit: this.pageSize,
        skit: 0,
        search: this.search,
        CreateBy: this.selectedCreator, // != null ? this.selectedCreator : this.currentUser.EmployeeId
        StatusSoftwareDeveloper: this.StatusSoftwareDeveloperSelected,
        DirectionsTI: this.ChangesDirectionsIT,
        yearMonth: this.yearMonth
      };

      this.loading = true;

      this.$http
        .get("/api/InternalServiceRequest/GetSummaryInternalService", {
          params: params,
          timeout: 3 * 60 * 1000
        })
        .then((response) => {
          const { data } = response;
          this.cardValues = data;
        });

      this.$http
        .get(
          "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisor/",
          {
            params: params,
            //cancelToken: axiosSource.token,
            timeout: 3 * 60 * 1000
          }
        )
        .then((resp) => {
          const { Items, CurrentPage, ItemCount } = resp.data;

          this.currentPage = CurrentPage;
          this.total = ItemCount;
          this.items = Items;

          this.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", false);

          this.$nextTick(function () {
            let p = this.$refs[this.activeTab].pagination;
            this.$refs[this.activeTab].pagination = {
              ...p,
              currentPage: CurrentPage,
              total: ItemCount
            };
          });
        })
        .finally(() => (this.loading = false));
    },

    getItemsForChart() {
      /*
      if (this.request) this.cancel();

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      */
      const { /*EmployeeId,*/ CompanySelected, IsSupervisor } =
        this.currentUser;
      const person = this.selectedEmployee; //> 0 ? this.selectedEmployee : EmployeeId;

      const params = {
        PersonId: person,
        DirectionId: this.selectedDirection,
        Company: CompanySelected,
        Status: this.selectedStatus,
        CreateByMe: this.switchCreateByMe,
        IAmASupervisor: this.switchIAmASupervisor,
        All: this.setAllMyRequests,
        isSupervisor: IsSupervisor,
        page: this.currentPage,
        limit: 1000,
        skit: 0,
        search: this.search,
        CreateBy: this.selectedCreator // != null ? this.selectedCreator : this.currentUser.EmployeeId
      };

      this.loadingGraph = true;
      /*
      this.$http
        .get("/api/InternalServiceRequest/GetSummaryInternalService", {
          params: params,
          timeout: 3 * 60 * 100
        })
        .then(response => {
          const { data } = response;
          this.cardValues = data;
        });
    */
      this.$http
        .get(
          "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisorForGhart/",
          {
            params: params,
            //cancelToken: axiosSource.token,
            timeout: 3 * 60 * 1000
          }
        )
        .then((resp) => {
          const Items = resp.data;
          this.items2 = Items;
        })
        .finally(() => (this.loading = false));
    },
    async handlePushAction(option) {
      switch (option.command) {
        case "set": {
          this.dialog.internalRequestId = option.row.Id;
          this.dialog.title = "Asignar responsable";
          this.dialog.type = "set";
          this.dialog.visible = true;
          break;
        }
        case "setProgress": {
          this.dialog.internalRequestId = option.row.Id;
          this.dialog.title = "Cambiar progreso";
          this.dialog.type = "setProgress";
          this.dialog.visible = true;
          break;
        }

        case "changesDirectionIT": {
          this.dialog.internalRequestId = option.row.Id;
          this.dialog.title = "Cambiar Dirección IT (Interna o Externa)";
          this.dialog.type = "changesDirectionIT";
          this.dialog.visible = true;
          break;
        }

        case "addComment": {
          this.dialog.internalRequestId = option.row.Id;
          this.dialog.title = "Agregar comentario";
          this.dialog.type = "addComment";
          this.dialog.visible = true;
          break;
        }

        case "cancell": {
          this.__helperRequestChangeStatus(4, option.row.Id);
          break;
        }

        case "work": {
          this.__helperRequestChangeStatus(1, option.row.Id);
          break;
        }

        case "close": {
          this.IDRequest = option.row.Id;

          await this.KnowIfThereIsTimeToAsign(option.row).then((data) => {
            const isThereTimeToAsign = data;
            // if (this.fileList !== "" && this.fileList !== undefined) {
            //   this.__helperRequestChangeStatus(2, option);
            //   break;
            // }
            if (isThereTimeToAsign === false) {
              this.$alert(
                "Debes de subir una evidencia para poder cerrar la solicitud",
                "Falta evidencia",
                {
                  type: "error"
                }
              );

              this.dialogVisible = true;
            } else {
              this.$alert(
                "Aun tiene tareas o solicitudes pendientes de asignarles tiempo, " +
                  "para ello dirijase al reporte de tareas en mis solicitudes o" +
                  "comuniquese con su supervisor  para asignarles tiempo.",
                "Tiene Solicitudes o tareas sin tiempo asignado",
                {
                  type: "error"
                }
              );
            }
          });

          break;
        }

        case "details": {
          this.dialog.internalRequestId = option.row.Id;
          this.detailData = {
            requestsId: option.row.Id,
            comments: [],
            descripcionLaga: option.row.Descripcion,
            descripcionCorta: option.row.corta,
            commentReasonToReopen: option.row.ReasonToReopen,
            Reopen: option.row.Reopen,
            evidences: []
          };
          if (option.row != null && option.row.Activities != null) {
            const c = option.row.Activities.filter((a) => (a.Type = 1));
            this.detailData.comments = JSON.parse(JSON.stringify(c));
          }
          this.showDetail = true;
          break;
        }
        case "evidences": {
          let dataEvidences = [];
          this.$http
            .get(`/api/InternalServiceRequest/getEvidences`, {
              params: { InternalRequestId: option.row.Id }
            })
            .then(({ data }) => {
              dataEvidences = data;
              if (data.Evidences === null) {
                this.$message({
                  type: "warning",
                  message: "Esta solicitud aún no tiene evidencias"
                });
                return;
              }
              let a = document.createElement("a");
              a.setAttribute("href", dataEvidences.Evidences);
              a.target = "_blank";
              a.click();
            })
            .finally(() => {
              this.evideLoading = false;
            });
          break;
        }
        case "reopen": {
          this.dialog.internalRequestId = option.row.Id;
          this.dialog.title =
            "Agrega tu comentario del porque se debe 'Reabrir la solicitud'";
          this.dialog.type = "addcommentReasonToReopen";
          this.dialog.visible = true;
          break;
        }

        default:
          break;
      }
    },
    handleCloseDialog(done) {
      done();
    },
    confirmDialog() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.dialog.type === "set") {
            this.$http
              .get("/api/InternalServiceRequest/SetResponsable", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  responsableId: this.dialog.responsableId,
                  supervisorId: this.currentUser.EmployeeId
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                if (resp.data) {
                  this.$message({
                    type: "success",
                    message: "Responsable establecido exitosamente!"
                  });
                } else {
                  this.$message.error("Error al establecer responsable");
                }
              })
              .catch((error) => {
                this.$message.error("Error al establecer responsable", error);
              })
              .finally(() => {
                this.cancelDialog();
                this.getItems();
              });
          } else if (this.dialog.type === "addComment") {
            this.$http
              .get("/api/InternalServiceRequest/addComments", {
                params: {
                  comments: this.dialog.comment,
                  internalRequestId: this.dialog.internalRequestId,
                  createBy: this.currentUser.EmployeeId,
                  tipo: 1
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                if (resp.data) {
                  this.$message({
                    type: "success",
                    message: "comentario agregado exitosamente!"
                  });
                } else {
                  this.$message.error("Error al agregar comentario");
                }
              })
              .catch((error) => {
                this.$message.error("Error al agregar comentario", error);
              })
              .finally(() => {
                this.cancelDialog();
                this.getItems();
              });
          } else if (this.dialog.type === "setProgress") {
            this.$http
              .get("/api/InternalServiceRequest/setProgress", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  StatusSoftwareDeveloper: this.dialog.StatusSoftwareDeveloper
                },
                timeout: 3 * 60 * 100
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "Estado actualizado exitosamente!"
                });
              })
              .catch((error) => {
                this.$message.error("Error al editar el estado", error);
              })
              .finally(() => {
                this.cancelDialog();
                this.getItems();
              });
          } else if (this.dialog.type === "addcommentReasonToReopen") {
            this.$http
              .get("/api/InternalServiceRequest/reOpen", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  commentReasonToReopen: this.dialog.commentReasonToReopen
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                if (resp.status == 200) {
                  this.$message({
                    type: "success",
                    message: "Solicitud reabierta exitosamente!"
                  });
                } else {
                  this.$message.error("Error al reabrir solicitud");
                }
              })
              .catch((error) => {
                this.$message.error("Error al reabrir solicitud", error);
              })
              .finally(() => {
                this.cancelDialog();
                this.getItems();
              });
          } else if (this.dialog.type === "changesDirectionIT") {
            this.$http
              .get("/api/InternalServiceRequest/changesDirectionTI", {
                params: {
                  internalRequestId: this.dialog.internalRequestId,
                  DirectionsTI: this.dialog.ChangesDirectionsIT
                },
                timeout: 3 * 60 * 100
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "Dirección actualizado exitosamente!"
                });
              })
              .catch((error) => {
                this.$message.error("Error al editar el Dirección", error);
              })
              .finally(() => {
                this.cancelDialog();
                this.getItems();
              });
          }
        } else {
          return false;
        }
      });
    },
    cancelDialog() {
      this.dialog.visible = false;
      this.$refs.form.resetFields();
    },
    __helperRequestChangeStatus(status, option) {
      this.$http
        .get("/api/InternalServiceRequest/SetStatusInRequestByTecnical", {
          params: {
            internalRequestId: option,
            status: status,
            userId: this.currentUser.EmployeeId
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.$message({
              type: "success",
              message: "Estado de solicitud actualizado exitosamente!"
            });
          } else {
            this.$message.error("Error al establecer Estado de la solcitud");
          }
        })
        .catch((error) => {
          this.$message.error(
            "Error al establecer Estado de la solcitud",
            error
          );
        })
        .finally(() => {
          this.getItems();
        });
    },
    handleSearch(val) {
      this.currentPage = 1;
      this.selectedStatus = -1;

      this.$nextTick(function () {
        let p = this.$refs[this.activeTab].pagination;
        this.$refs[this.activeTab].pagination = {
          ...p,
          currentPage: 1
        };
      });

      this.search = val;
      this.getItems();

      this.$nextTick(() => {
        this.activeTab = "all";
      });
    },
    closeInternalRequestDrawer() {
      this.showDetail = false;
    },
    handleUploadOnSuccess(response) {
      this.fileList = response[0];
      var url = "/api/InternalServiceRequest/addEvidences";
      this.$http
        .get(url, {
          params: {
            evidences: this.fileList.Url,
            internalRequestId: this.IDRequest,
            createBy: this.currentUser.EmployeeId,
            tipo: 0
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          if (resp.data) {
            this.$message({
              type: "success",
              message: "evidencia agregada exitosamente!"
            });
            this.$refs.uploadFile.clearFiles();
            this.filesUpload = 0;
          } else {
            this.$message.error("Error al agregar evidencia");
          }
        })
        .catch((error) => {
          this.$message.error("Error al agregar evidencia", error);
        })
        .finally(() => {
          this.dialogVisible = false;
          this.getItems();
        });
      this.__helperRequestChangeStatus(2, this.IDRequest);
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    submitUpload() {
      this.$refs.uploadFile.submit();
    },
    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    },
    SetDataChart(items2) {
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];
      this.Directions.forEach((dir) => {
        this.chartData.labels.push(dir.label);
        this.chartData.datasets[0].data.push(
          items2.filter((item) => item.DirecctionID === dir.value).length
        );
        if (dir.Color !== null) {
          this.chartData.datasets[0].backgroundColor.push(dir.Color);
        } else {
          this.chartData.datasets[0].backgroundColor.push(
            Math.floor(Math.random() * 16777215).toString(16)
          );
        }
      });
      this.PieChartKey++;
      this.$refs.pieChart.RerenderChart(this.chartData, this.options);
      this.loadingGraph = false;
    },
    onEvidenceClose() {
      this.$refs.uploadFile.clearFiles();
    },
    async KnowIfThereIsTimeToAsign(row) {
      let isThereTimeToAsignPromise = await new Promise((resolve, reject) => {
        // this.loadingData = true;
        this.TasksData = [];
        // await Promise.all(
        this.$http
          .get("/api/ReporteGestion/KnowIfThereAreTasksWithoutTimeAsigned", {
            params: {
              CompanySelected: "TB",
              GerenciaID: row.DirecctionID,
              ResponsableID: row.ResponsableID,
              WeekOnMothSelected: null,
              Year: null,
              Month: null,
              closed: false
            }
          })
          .then((response) => {
            //this.loadingData = false;
            resolve(response.data);
          })
          .catch((err) => {
            // this.loadingData = false;
            this.$message.error("Error al cargar los datos de las tareas.");
            reject(err);
          })
          .finally(() => {
            // this.loadingData = false;
          });
      });
      return isThereTimeToAsignPromise;
    }
  },
  watch: {
    switchIAmASupervisor(val) {
      if (val) {
        this.disableCreatorSelector = false;
        this.disableEmployeeSelector = false;
        this.switchCreateByMe = false;
        this.setAllMyRequests = false;
      }
    },
    switchCreateByMe(val) {
      if (val) {
        this.disableCreatorSelector = true;
        this.disableEmployeeSelector = false;
      } else {
        this.disableCreatorSelector = false;
        this.disableEmployeeSelector = true;
      }

      if (this.setAllMyRequests) {
        this.switchCreateByMe = false; // No permite cambiarla mientras setAllMyRequest esta activo
        this.disableCreatorSelector = false;
        this.disableEmployeeSelector = false;
      }

      this.getItems();
    },
    setAllMyRequests(val) {
      this.selectedEmployee = null;
      this.selectedCreator = null;

      if (val) {
        this.switchCreateByMe = false;
        this.disableCreatorSelector = false;
        this.disableEmployeeSelector = false;
      } else {
        this.disableCreatorSelector = false;
        this.disableEmployeeSelector = true;
        this.yearMonth = new Date();
      }
      this.getItems();
    },
    yearMonth() {
      this.getItems();
    },
    updateInternalRequests(val) {
      if (val) {
        this.getItems();
      }
    },
    items2(val) {
      this.SetDataChart(val);
    }
  }
};
</script>

<style scoped>
/* .el-table .warning-row {
   background: none !important;
} */
/* .ChartSize {
} */
.flex-container {
  display: flex;
  /*flex-flow: row wrap;*/
  justify-content: center;
  height: 100%;
  width: 100%;
}

.box-cardG {
  width: 780px;
  position: relative;
  right: 50px;
}

#textG {
  position: relative;
  left: 260px;
}
</style>
